import React from "react";
import styles from "./ThemeSwitch.module.scss";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";

interface Props {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ThemeSwitch: React.FC<Props> = ({ checked, onChange }) => {
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        aria-label={checked ? "Switch to light mode" : "Switch to dark mode"}
      />
      <span className={styles.slider}>
        <span className={`${styles.icon} ${styles.sun}`}>
          <LightModeIcon />
        </span>
        <span className={`${styles.icon} ${styles.moon}`}>
          <DarkModeIcon />
        </span>
      </span>
    </label>
  );
};

export default ThemeSwitch;


